export default "__VITE_PUBLIC_ASSET__eca38159__"